module.exports = __webpack_public_path__ + "34ede4de97447bd1ac76c533b68a3e2c.png";